<template>
  <div class="timezone-select-field">
    <v-select
      :value="value"
      :items="allVariants"
      :label="label"
      item-text="name"
      item-value="value"
      outlined
      required
      :loading="loading"
      :disabled="loading || disabled"
      @change="emitInput"
      clearable
      v-bind="$attrs"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { isUndefined } from 'lodash'

  export default {
    name: 'EnumValueSelectField',
    props: {
      value: {
        type: [String, Number],
        default: null,
      },
      label: {
        type: String,
        default: 'Часовой пояс',
      },
      enumClass: null,
      loading: Boolean,
      disabled: Boolean,
    },
    computed: {
      allVariants () {
        return this.enumClass ? this.enumClass.getAllVariants() : []
      },
      ...mapGetters({
        timezones: 'app/getTimezones',
      }),
    },
    methods: {
      emitInput (value) {
        if (isUndefined(value)) {
          value = null
        }
        this.$emit('input', value)
      },
    },
    created () {
      if (!this.enumClass) {
        throw new Error('enumClass not defined in EnumValueSelectField component')
      }
    },
  }
</script>

<style scoped>

</style>
